import { render, staticRenderFns } from "./TixstockFeaturedCategories.vue?vue&type=template&id=36202fb8"
import script from "./TixstockFeaturedCategories.vue?vue&type=script&lang=js"
export * from "./TixstockFeaturedCategories.vue?vue&type=script&lang=js"
import style0 from "./TixstockFeaturedCategories.vue?vue&type=style&index=0&id=36202fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports